import { FlowTagCategory } from 'flow-schema';

import { type api, isDefined, isTruthy } from 'common';

interface TagWithCategory extends Omit<api.FlowDefinition.FlowTag, 'category'> {
  category: FlowTagCategory;
}

interface FormDataTags {
  useCaseTag?: string | null;
  flowTypeTag?: string | null;
  supportedEhrTags?: string[] | null;
  customTags?: string[] | null;
  noCategoryTags?: string[] | null;
}

export function convertTagsToApiValue(
  args: Omit<FormDataTags, 'noCategoryTags'>
): TagWithCategory[] {
  const { useCaseTag, flowTypeTag, supportedEhrTags, customTags } = args;

  const tags: TagWithCategory[] = [];
  if (isDefined(useCaseTag)) {
    tags.push({ name: useCaseTag, category: FlowTagCategory.UseCase });
  }
  if (isDefined(flowTypeTag)) {
    tags.push({ name: flowTypeTag, category: FlowTagCategory.FlowType });
  }
  if (isDefined(supportedEhrTags)) {
    tags.push(
      ...supportedEhrTags.map((tag) => ({ name: tag, category: FlowTagCategory.SupportedEhr }))
    );
  }
  if (isDefined(customTags)) {
    tags.push(...customTags.map((tag) => ({ name: tag, category: FlowTagCategory.Custom })));
  }
  return tags;
}

export function convertTagsToFormData(args: {
  tags?: api.FlowDefinition.FlowTag[] | null;
}): FormDataTags {
  const { tags } = args;
  if (!isDefined(tags)) {
    return {};
  }

  const useCaseTag = tags.find((tag) => tag.category === FlowTagCategory.UseCase);
  const flowTypeTag = tags.find((tag) => tag.category === FlowTagCategory.FlowType);
  const supportedEhrTags = tags.filter((tag) => tag.category === FlowTagCategory.SupportedEhr);
  const customTags = tags.filter((tag) => tag.category === FlowTagCategory.Custom);
  const noCategoryTags = tags.filter((tag) => !isDefined(tag.category));

  return {
    useCaseTag: useCaseTag?.name,
    flowTypeTag: flowTypeTag?.name,
    supportedEhrTags: isTruthy(supportedEhrTags.length)
      ? supportedEhrTags.map((tag) => tag.name)
      : undefined,
    customTags: isTruthy(customTags.length) ? customTags.map((tag) => tag.name) : undefined,
    noCategoryTags: isTruthy(noCategoryTags.length)
      ? noCategoryTags.map((tag) => tag.name)
      : undefined,
  };
}
